const t = {
  title: "Увы, не удалось произвести расчет",
  description: "К сожалению, мы не смогли найти результаты, соответствующие всем выбранным вами критериям. Попробуйтe изменить некоторые параметры."
};
export {
  t as ERROR_STAGE_CONTENT
};
